import { render, staticRenderFns } from "./Franquicias.vue?vue&type=template&id=d9805aa2&scoped=true&"
import script from "./Franquicias.vue?vue&type=script&lang=js&"
export * from "./Franquicias.vue?vue&type=script&lang=js&"
import style0 from "./Franquicias.vue?vue&type=style&index=0&id=d9805aa2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9805aa2",
  null
  
)

export default component.exports